module.exports = __webpack_public_path__ + "static/media/Butterfly_3_small.a0b88219.png";